import * as NoOpMapItem from "@discovery/components-dplus/lib/components/atoms/page";
import { ComponentId } from "@discovery/components-dplus/lib/component-creators/mapping";
import * as Footer from "@discovery/components-dplus/lib/component-creators/footer";
import * as Hamburger from "@discovery/components-dplus/lib/component-creators/hamburger";
import * as Hero from "@discovery/components-dplus/lib/component-creators/hero";
import * as Rails from "@discovery/components-dplus/lib/component-creators/rails";
import * as Shows from "@discovery/components-dplus/lib/component-creators/show-page";
import * as Tabs from "@discovery/components-dplus/lib/component-creators/tabs";
import * as VideoPageForShow from "@discovery/components-dplus/lib/component-creators/video-page";
import * as Explore from "@discovery/components-dplus/lib/component-creators/explore-shows";
import * as Shorts from "@discovery/components-dplus/lib/component-creators/shorts";
import * as BannerAds from "@discovery/components-dplus/lib/component-creators/banner-ads";
import * as MindBlown from "@discovery/components-dplus/lib/component-creators/mind-blown";
import * as MindBlownPageHero from "@discovery/components-dplus/lib/component-creators/mind-blown-page-hero";
import * as PremiumBanner from "@discovery/components-dplus/lib/component-creators/premium-banner";
import * as HeroSuperstar from "@discovery/components-dplus/lib/component-creators/hero-superstar";
import * as Search from "@discovery/components-dplus/lib/component-creators/search";
import * as MostPopularLists from "@discovery/components-dplus/lib/component-creators/content-lists";
import * as LikedVideos from "@discovery/components-dplus/lib/component-creators/liked-videos";
import * as PrivacyPolicy from "@discovery/components-dplus/lib/component-creators/privacy-policy";
import * as ActivateConnectedDevice from "@discovery/components-dplus/lib/component-creators/activate-connected-device";
import * as ContestHero from "@discovery/components-dplus/lib/component-creators/contest-hero";
import * as ContestNameSetup from "@discovery/components-dplus/lib/component-creators/contest-name-setup";
import * as ContestParticipated from "@discovery/components-dplus/lib/component-creators/contest-participated";
import * as ContestStart from "@discovery/components-dplus/lib/component-creators/contest-start";
import * as FeaturedStandAlone from "@discovery/components-dplus/lib/component-creators/featured-standalone";
import * as LiveTvChannelList from "@discovery/components-dplus/lib/component-creators/live-tv-channel-list";
import * as LiveTvPlayer from "@discovery/components-dplus/lib/component-creators/live-tv-player";
import * as Gifiting from "@discovery/components-dplus/lib/component-creators/gifiting-cooperate";
import * as PricePlan from "@discovery/components-dplus/lib/component-creators/price-plan";
import * as SuperstarRails from "@discovery/components-dplus/lib/component-creators/superstar-rails";
import * as PromotionalBanner from "@discovery/components-dplus/lib/component-creators/promotional-banner";
import * as ExploreLandingPage from "@discovery/components-dplus/lib/component-creators/explore";
import * as ContestListing from "@discovery/components-dplus/lib/component-creators/contest-listing";
import * as UserReview from "@discovery/components-dplus/lib/component-creators/user-review";
import * as PlatformPromotion from "@discovery/components-dplus/lib/component-creators/platform-promotion";
import * as SizzleReel from "@discovery/components-dplus/lib/component-creators/sizzle-reel";
import * as NetworkLogos from "@discovery/components-dplus/lib/component-creators/network-logos";
import * as PricePlanCompare from "@discovery/components-dplus/lib/component-creators/price-plan-compare";
import * as FeaturedShowRail from "@discovery/components-dplus/lib/component-creators/featured-show-rail";
import * as ContentGroup from "@discovery/components-dplus/lib/component-creators/content-group";
export const componentMapper = {
    [ComponentId.Hamburger]: Hamburger.ComponentMapItem,
    [ComponentId.Footer]: Footer.ComponentMapItem,
    [ComponentId.Rails]: Rails.ComponentMapItem,
    [ComponentId.Hero]: Hero.ComponentMapItem,
    [ComponentId.ShowHero]: Shows.ComponentMapItem,
    [ComponentId.VideoHero]: VideoPageForShow.ComponentMapItem,
    [ComponentId.Search]: Search.ComponentMapItem,
    [ComponentId.ContentLists]: MostPopularLists.ComponentMapItem,
    [ComponentId.LikedVideos]: LikedVideos.ComponentMapItem,
    [ComponentId.ShowTabs]: Tabs.ComponentMapItem,
    [ComponentId.SuperstarHero]: HeroSuperstar.ComponentMapItem,
    [ComponentId.Shorts]: Shorts.ComponentMapItem,
    [ComponentId.PrivacyPolicy]: PrivacyPolicy.ComponentMapItem,
    [ComponentId.MindBlown]: MindBlown.ComponentMapItem,
    [ComponentId.MindBlownPageHero]: MindBlownPageHero.ComponentMapItem,
    [ComponentId.Explore]: Explore.ComponentMapItem,
    [ComponentId.PremiumBanner]: PremiumBanner.ComponentMapItem,
    [ComponentId.FeaturedStandAlone]: FeaturedStandAlone.ComponentMapItem,
    [ComponentId.ActivateConnectedDevice]: ActivateConnectedDevice.ComponentMapItem,
    [ComponentId.BannerAds]: BannerAds.ComponentMapItem,
    [ComponentId.LiveTvPlayer]: LiveTvPlayer.ComponentMapItem,
    [ComponentId.LiveTvChannelList]: LiveTvChannelList.ComponentMapItem,
    [ComponentId.ContestNameSetup]: ContestNameSetup.ComponentMapItem,
    [ComponentId.ContestImage]: ContestHero.ComponentMapItem,
    [ComponentId.ContestStart]: ContestStart.ComponentMapItem,
    [ComponentId.ContestAlreadyParticipated]: ContestParticipated.ComponentMapItem,
    [ComponentId.Inquiry]: Gifiting.ComponentMapItem,
    [ComponentId.PricePlan]: PricePlan.ComponentMapItem,
    [ComponentId.SuperstarRails]: SuperstarRails.ComponentMapItem,
    [ComponentId.PromotionalBanner]: PromotionalBanner.ComponentMapItem,
    [ComponentId.ExploreChannelAndShows]: ExploreLandingPage.ComponentMapItem,
    [ComponentId.ContestListing]: ContestListing.ComponentMapItem,
    [ComponentId.UserReview]: UserReview.ComponentMapItem,
    [ComponentId.PlatformPromotion]: PlatformPromotion.ComponentMapItem,
    [ComponentId.SizzleReel]: SizzleReel.ComponentMapItem,
    [ComponentId.NetworkLogos]: NetworkLogos.ComponentMapItem,
    [ComponentId.PricePlanCompare]: PricePlanCompare.ComponentMapItem,
    [ComponentId.FeaturedShowRail]: FeaturedShowRail.ComponentMapItem,
    [ComponentId.ContentGroup]: ContentGroup.ComponentMapItem,
    default: NoOpMapItem.ComponentMapItem,
};
